module.exports = "/_next/static/images/TheGrowthReport-1e9d1055ccebeb5621f8491bb3cef919.webp";